import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export interface NewsArticle {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  body?: string;
  coverImage: string;
  sourceType: string;
  sourcePlayerExternalId?: string;
  sourceTeamExternalId?: string;
  playerPath?: string;
  teamPath?: string;
  publishedAt: string;
}

export interface NewsListResponse {
  count: number;
  limit: number;
  offset: number;
  data: NewsArticle[];
}

export const useNewsList = (
  params: { limit?: number; offset?: number } = {},
  options?: Omit<UseQueryOptions<NewsListResponse, Error>, "queryKey" | "queryFn">
) => {
  const limit = params.limit ?? 20;
  const offset = params.offset ?? 0;
  return useQuery({
    queryKey: ["news", "list", limit, offset],
    queryFn: async () => {
      const { data } = await apiClient.get<NewsListResponse>("/news", {
        params: { limit, offset },
      });
      return data;
    },
    staleTime: 60 * 1000,
    ...options,
  });
};

export const useNewsArticle = (
  slug: string | undefined,
  options?: Omit<UseQueryOptions<NewsArticle, Error>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["news", "slug", slug ?? ""],
    queryFn: async () => {
      const { data } = await apiClient.get<NewsArticle>(`/news/${slug}`);
      return data;
    },
    enabled: Boolean(slug),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
